import type { DeliveryPointInfoResponse, LocationCoordinates } from './types'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher/client'

export const isLocationInDeliveryArea = async (
  coordinates: LocationCoordinates
): Promise<boolean> => {
  const { longitude, latitude } = normalizeLocationCoordinates(coordinates)

  const { apiUrl } = getConfig()
  const response = await fetcher.get<DeliveryPointInfoResponse>(
    `${apiUrl}/customer_profile/api/v1/guest/address_book/delivery_point_info?latitude=${latitude}&longitude=${longitude}`
  )
  const isInsideDeliveryArea = response.data.data.valid
  return isInsideDeliveryArea
}

/**
 *
 * Normalize the coordinates to be within the range of -180 to 180 for longitude and -90 to 90 for
 * latitude. When the coordinates are outside the range, they are wrapped around the globe,
 * generating this way a set of coordinates that are within the range.
 *
 */
export const normalizeLocationCoordinates = (
  coordinates: LocationCoordinates
): LocationCoordinates => {
  const wrappedLongitude = ((((coordinates.longitude + 180) % 360) + 360) % 360) - 180
  const wrappedLatitude =
    Math.asin(Math.sin(coordinates.latitude * (Math.PI / 180))) * (180 / Math.PI)
  return {
    longitude: wrappedLongitude,
    latitude: wrappedLatitude,
  }
}
